import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { AddressType, Address } from '../entities';

const c = initContract();


export const AddressSchema = z.object({
    _id: z.string(),
    name: z.string().optional(),
    color: z.string().optional(),
    data: z.any().optional(),
    active: z.boolean().optional(),
    system: z.boolean().optional(),

    street1: z.string().optional(),
    street2: z.string().optional(),
    suburb: z.string().optional(),
    county: z.string().optional(),
    state: z.string().optional(),
    postcode: z.number().optional(),
    postalCode: z.string().optional(),
    country: z.string().optional(),
    lat: z.number().optional(),
    lgn: z.number().optional(),
    timezone: z.string().optional(),
    matchKey: z.string().optional(),
    type: z.nativeEnum(AddressType).optional(),
});

export const AddressSearchContract = c.router(
    {
        search: {
            method: 'GET',
            path: '/rpc',
            responses: {
                201: z.array(AddressSchema),
            },
            query: z.object({
                s: z.string()
            }),
            summary: 'Search address',
        },
    },
    // {
    //     pathPrefix: '/address/search'
    // }
);